<template>
  <div class="content py-5">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        Solicitação de Reserva
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <download-excel
                  :data="data"
                  :fields="json_fields"
                  name="solicitacao-de-reserva.xls"
                >
                  <v-btn block color="success" class="white--text mt-3">
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          class=" elevation-1"
          no-data-text="Sem solicitação de reservas"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.vehicle.id }}</td>
              <td class>{{ item.user.name }}</td>
              <td class>{{ item.vehicle.model }}</td>
              <td class>{{ item.created_date | formatDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleRequestController from '../../controllers/VehicleRequestController.js';

export default {
  async created() {
    await this.getVehicleRequestReport();
  },

  data() {
    return {
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,
      vehicleRequestController: new VehicleRequestController(this.$resource),

      data: [],
      search: '',

      json_fields: {
        Id: 'vehicle.id',
        Usuário: 'user.name',
        Veículo: 'vehicle.model',
        Data: 'created_date',
      },
      headers: [
        { text: 'ID', value: 'vehicle.id' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Veículo', value: 'vehicle.model' },
        { text: 'Data', value: 'created_date' },
      ],
    };
  },

  methods: {
    async getVehicleRequestReport() {
      try {
        this.blockScreen = true;
        let response = await this.vehicleRequestController.getVehicleRequestReport();
        this.data = response;
      } catch (error) {
        this.$awn.success(error);
      } finally {
        this.blockScreen = false;
      }
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm:ss');
      }
    },
  },
};
</script>
